"use strict";
exports.__esModule = true;
var ChartBreakdownKey = /** @class */ (function () {
    function ChartBreakdownKey(_a) {
        var label = _a.label, value = _a.value;
        var _this = this;
        this.toJSON = function () { return ({
            label: _this.label,
            value: _this.value
        }); };
        this.label = label;
        this.value = value;
    }
    ChartBreakdownKey.fromJSON = function (json) {
        var _a = Object.assign({}, json), label = _a.label, value = _a.value;
        if (typeof label !== 'string')
            throw new Error('.label must be a string');
        if (typeof value !== 'string')
            throw new Error('.value must be a string');
        return new ChartBreakdownKey({
            label: label,
            value: value
        });
    };
    return ChartBreakdownKey;
}());
exports["default"] = ChartBreakdownKey;
